import React from "react";
import { isEmpty } from "lodash";
import { CloseDialog } from "components/Dialog";
import Button from "components/Button";
import Dialog from "components/Dialog";
import Input from "components/Input";
import classes from "../style.module.scss";

const CreateDialog = ({
    title,
    label,
    placeholder,
    openDialog,
    newName,
    setNewName,
    onClick,
    onClose,
    isLoading,
}) => {
    const isDisabled = isLoading || isEmpty(newName);

    return (
        <Dialog open={!!openDialog} actionkey={"Enter"} closeActions={() => { if (!isDisabled) onClick(); }}>
            <CloseDialog closeActions={() => onClose()} />
            <div className={classes.dialog}>
                <h2>{title}</h2>
                <Input
                    label={label}
                    placeholder={placeholder}
                    disabled={isLoading}
                    input={{
                        value: newName,
                        onChange: (value) => setNewName(value),
                    }}
                />
                <div className={classes.footer}>
                    <Button type="hollow" onClick={() => onClose()}>
                        Cancel
                    </Button>
                    <Button onClick={onClick} type="" disabled={isDisabled}>
                        {isLoading ? "Creating..." : "Create"}
                    </Button>
                </div>
            </div>
        </Dialog>
    )
};

export default CreateDialog;

export const CreateFolderDialog = ({
    openDialog,
    newFolderName,
    setNewFolderName,
    onClick,
    onClose,
    folderLoading,
}) => (
    <CreateDialog
        title="Create a New Folder"
        label="Folder Name"
        placeholder="Type folder name..."
        openDialog={openDialog}
        newName={newFolderName}
        setNewName={setNewFolderName}
        onClick={onClick}
        onClose={onClose}
        isLoading={folderLoading}
    />
);

export const CreateCommunityDialog = ({
    openDialog,
    newCommunityName,
    setNewCommunityName,
    onClick,
    onClose,
    communityLoading,
}) => (
    <CreateDialog
        title="Create a New Community"
        label="Community Name"
        placeholder="Type community name..."
        openDialog={openDialog}
        newName={newCommunityName}
        setNewName={setNewCommunityName}
        onClick={onClick}
        onClose={onClose}
        isLoading={communityLoading}
    />
);
